import { Logger } from '@mrkt/features/Platform';
import { webgateFetch } from '@mrkt/features/webgate-fetch';

import { useCurrentArtistIdOrNull } from '../../../artists';
import { Org, Provider } from '../types';
import { fundraisingServiceUrl } from './constants';

async function _put(
  link: string,
  providerOrOrg: Provider | Org,
  artistId: string,
) {
  const endpoint = `${fundraisingServiceUrl}/v1/artist/${artistId}`;

  try {
    return await webgateFetch(endpoint, {
      body: JSON.stringify({ link, provider: providerOrOrg }),
      method: 'put',
    });
  } catch (e) {
    Logger.logError('artist-fundraising-pick-put-error', e);
    return null;
  }
}

export function usePut() {
  const artistId = useCurrentArtistIdOrNull();

  return async function put(
    linkValue: string,
    providerOrOrgValue: Provider | Org,
  ) {
    if (artistId) {
      return await _put(linkValue, providerOrOrgValue, artistId);
    }

    return null;
  };
}
